const CalendarIcon = ({successColor, disabled}) => {
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="25"
      fill="none"
      viewBox="0 0 28 25"
    >
      <g clipPath="url(#clip0_393_2196)">
        <mask
          id="mask0_393_2196"
          style={{ maskType: "alpha" }}
          width="28"
          height="25"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            d="M21.472.156h2.025l.004.004h.257v1.559H21.212V.16h.26V.156zM8.813 8.75l.52.01v4.678h-5.09V8.76h.52l4.05-.01zm0 7.031l.52.01v4.678h-5.09V15.79h.52l4.05-.01zm6.788-7.031l.52.01v4.678H11.03V8.76h.52l4.051-.01zm0 7.031l.52.01v4.678H11.03V15.79h.52l4.051-.01zM22.39 8.75l.52.01v4.678H17.818V8.76h.52l4.051-.01zM3.654.156H5.68V.16h.26v1.559H3.393V.16h.26V.156zm-1.109 6.64V22.34c0 .26-.012.474-.028.474H.877c-.016 0-.029-.214-.029-.474V6.797h1.697zm24.606.016V22.34c0 .26-.012.473-.028.473h-1.64c-.016 0-.028-.213-.028-.473V6.812h1.697zm.425-3.296v1.668c0 .028-.013.05-.029.05h-1.64c-.015 0-.028-.022-.028-.05V3.516h1.697zm-25.455 0v1.668c0 .028-.013.05-.028.05H.453c-.016 0-.029-.022-.029-.05V3.516h1.697zm25.03 20.859H1.627c-.428 0-.778-.012-.778-.026v-1.51c0-.015.35-.026.778-.026h25.525v1.562zm.425-20.86H1.227c-.442 0-.803-.011-.803-.026V1.98c0-.014.361-.026.803-.026h26.349v1.563zm0 3.282H1.227c-.442 0-.803-.012-.803-.026V5.26c0-.015.361-.027.803-.027h26.349v1.563z"
          ></path>
        </mask>
        <g mask="url(#mask0_393_2196)">
          <path
            fill="#0E6993"
            d="M21.472.156h2.025l.004.004h.257v1.559H21.212V.16h.26V.156zM8.813 8.75l.52.01v4.678h-5.09V8.76h.52l4.05-.01zm0 7.031l.52.01v4.678h-5.09V15.79h.52l4.05-.01zm6.788-7.031l.52.01v4.678H11.03V8.76h.52l4.051-.01zm0 7.031l.52.01v4.678H11.03V15.79h.52l4.051-.01zM22.39 8.75l.52.01v4.678H17.818V8.76h.52l4.051-.01zM3.654.156H5.68V.16h.26v1.559H3.393V.16h.26V.156zm-1.109 6.64V22.34c0 .26-.012.474-.028.474H.877c-.016 0-.029-.214-.029-.474V6.797h1.697zm24.606.016V22.34c0 .26-.012.473-.028.473h-1.64c-.016 0-.028-.213-.028-.473V6.812h1.697zm.425-3.296v1.668c0 .028-.013.05-.029.05h-1.64c-.015 0-.028-.022-.028-.05V3.516h1.697zm-25.455 0v1.668c0 .028-.013.05-.028.05H.453c-.016 0-.029-.022-.029-.05V3.516h1.697zm25.03 20.859H1.627c-.428 0-.778-.012-.778-.026v-1.51c0-.015.35-.026.778-.026h25.525v1.562zm.425-20.86H1.227c-.442 0-.803-.011-.803-.026V1.98c0-.014.361-.026.803-.026h26.349v1.563zm0 3.282H1.227c-.442 0-.803-.012-.803-.026V5.26c0-.015.361-.027.803-.027h26.349v1.563z"
          ></path>
          <path
            className={`${disabled ? 'appt-disabled': successColor ? 'appt-scheduled' : 'appt-to-schedule'}`}
            d="M30.546-2.344h-33.94v31.25h33.94v-31.25z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_393_2196">
          <path fill="#fff" d="M0 0H28V25H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CalendarIcon;